export default "__VITE_ASSET__Db2CTjpE__"